import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';


export default function ButtonAppBar({titleHead}) {
	let navigate = useNavigate();
	  
	  const handleLogOut = () => {
		sessionStorage.removeItem("Auth Token");
		navigate('/');
		}
	
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed">
        <Toolbar>
		  <Avatar alt="Remy Sharp" src="https://source.unsplash.com/random/girl" onClick={() => {navigate('/profile')}} sx={{mr: 2}}/>       
		  <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {titleHead}
          </Typography>
          <Button variant="outlined" color="inherit" onClick={handleLogOut}>Logout</Button>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
